import { useEffect, useState } from 'react'

/** "~45s" or "~2 min" (John, Nov 1 2026: "estimated to arrive in ~45s") */
export function formatEta(seconds: number) {
  if (seconds < 60) return `~${Math.max(1, Math.round(seconds))}s`
  return `~${Math.round(seconds / 60)} min`
}

export type Countdown = { remaining: number; elapsed: number; eta: number }

/** what is left of an estimate that started at `startedAt`, ticking once a second while `running`; null without one */
export function useCountdown(startedAt: string | null | undefined, etaSeconds: number | null | undefined, running = true): Countdown | null {
  const [now, setNow] = useState(() => Date.now())
  const have = Boolean(startedAt) && etaSeconds !== null && etaSeconds !== undefined
  useEffect(() => {
    if (!running || !have) return
    setNow(Date.now())
    const timer = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(timer)
  }, [running, have, startedAt, etaSeconds])
  if (!have) return null
  const elapsed = (now - Date.parse(startedAt!)) / 1000
  return { remaining: Math.ceil(etaSeconds! - elapsed), elapsed, eta: etaSeconds! }
}

/** the words after a progress line: "~38s left", then "any moment now", then nothing once well past the estimate */
export function countdownText(countdown: Countdown | null) {
  if (!countdown) return ''
  if (countdown.remaining > 0) return countdown.remaining < 60 ? `~${countdown.remaining}s left` : `${formatEta(countdown.remaining)} left`
  if (countdown.elapsed < countdown.eta * 2 + 15) return 'any moment now'
  return ''
}
